class segmentsAll {
  constructor(segmId, name, days, despl, typeJor) {
    this.segmId = segmId;
    this.name = name;
    this.days = days;
    this.despl = despl;
    this.typeJor = typeJor;
  }
  static fromJson({ segmId, nombre, dias, desplJornada, tipoJornada }) {
    return new segmentsAll(segmId, nombre, dias, desplJornada, tipoJornada);
  }
}
export default segmentsAll;
